"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var __1 = require("../../");
axios_1.default.defaults.baseURL = 'https://pe.zkp.demo.trusttester.nl';
axios_1.default.interceptors.request.use(function (config) {
    var token = window.localStorage.getItem('jwt');
    if (token)
        config.headers.Authorization = "Bearer " + token;
    return config;
}, function (error) {
    return Promise.reject(error);
});
axios_1.default.interceptors.response.use(function (response) {
    var newToken = response.headers["set-authentication"];
    if (newToken) {
        window.localStorage.setItem('jwt', newToken);
    }
    return response;
});
axios_1.default.interceptors.response.use(undefined, function (error) {
    if (error.message === 'Network Error' && !error.response) {
        __1.history.push('/login');
    }
    throw error.response;
});
var responseBody = function (response) { return response.data; };
var sleep = function (ms) { return function (response) {
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(response); }, ms); });
}; };
var requests = {
    get: function (url) { return axios_1.default.get(url).then(sleep(1000)).then(responseBody); },
    post: function (url, body) { return axios_1.default.post(url, body).then(sleep(1000)).then(responseBody); },
    put: function (url, body) { return axios_1.default.put(url, body).then(sleep(1000)).then(responseBody); },
    del: function (url) { return axios_1.default.delete(url).then(sleep(1000)).then(responseBody); }
};
var User = {
    current: function () { return requests.get('/api/user'); },
    login: function (user) { return requests.post("/api/authenticate/login", user); },
    register: function (user) { return requests.post("/api/user/register", user); },
};
var Party = {
    list: function () { return requests.get('/Party/list'); },
    create: function (party) { return requests.post('/Party/create', party); },
    update: function (party) { return requests.post("/Party/edit", party); },
    delete: function (id) { return requests.del("/Party/delete?uid=" + id); }
};
var Question = {
    list: function (uid) { return requests.get("/Question/list?uid=" + uid); },
    create: function (question) { return requests.post('/Question/edit', question); },
};
exports.default = {
    User: User,
    Party: Party,
    Question: Question
};
//# sourceMappingURL=agent.js.map